import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import store from '@/store/store.js';
import AppMain from '@/components/AppMain.jsx';

function Main() {
    return (
        <div id="app-bounds">
            <Provider store={store}>
                <AppMain />
            </Provider>
        </div>
    );
}

document.addEventListener('DOMContentLoaded', () => {
    const root = createRoot(document.getElementById('main-path'));
    root.render(<Main/>);
});